import * as yup from "yup";

export const newCompanySchema = yup.object().shape({
  companyName: yup
    .string()
    .min(2, "A cég neve minimum 2 karakter hosszú kell legyen")
    .max(200, "A cég neve maximum 200 karakter lehet")
    .required("A cég név megadása kötelező"),
});
